<template>
  <div class="page page-account">
    <b-col class="py-3">
      <GameHeader :page-name="$t('Battle power rank')" />
      <RowLine />
      <div class="game-feature">
        <h1 class="feature-title">{{ $t("Battle power rank") }}</h1>
        <ValidationObserver
          ref="form"
          tag="form"
          class="form app-form"
          @submit.prevent="onSubmit()"
        >
          <b-form-group>
            <ValidationProvider rules="required" v-slot="{ errors }">
              <b-select
                v-model="formData.idServer"
                :options="servers"
                value-field="id"
                text-field="name"
                :disabled="loading || formData.idGame < 1"
              />
              <div class="msg-validate-error">{{ errors[0] }}</div>
            </ValidationProvider>
          </b-form-group>
        </ValidationObserver>
        <LoadingModal :show="loading" />
        <table class="ml-auto mr-auto table table-bordered" v-if="!loading">
          <thead>
            <tr>
              <th style="width: 50px">{{ $t("No.") }}</th>
              <th>{{ $t("Role name") }}</th>
              <th style="width: 120px">{{ $t("Level") }}</th>
              <th style="width: 120px">{{ $t("Battle power") }}</th>
            </tr>
          </thead>
          <tbody v-if="rank.length">
            <tr v-for="(r, i) in rank" :key="i">
              <th class="text-center">{{ $n(i + 1) }}</th>
              <td>{{ r.roleName }}</td>
              <td class="text-center">{{ $n(r.level) }}</td>
              <td class="text-center">{{ $n(r.battlePower) }}</td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="4" class="text-center">
                {{ $t("Rank table is updating") }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-col>
  </div>
</template>

<script>
import GameHeader from "@/components/headers/GameHeader";
import serverGameService from "@/services/serverGameService";
import dialogHelper from "@/helpers/dialogHelper";
import rankService from "../../../services/rankService";

export default {
  name: "Index",
  components: { GameHeader },
  data() {
    return {
      loading: false,
      servers: [
        {
          id: 0,
          name: this.$t("Select a server"),
        },
      ],
      formData: {
        idGame: 0,
        idServer: 0,
      },
      rank: [],
    };
  },
  created() {
    this.$bridge.$on("setCurrentGame", this.onSetGame);
  },
  beforeDestroy() {
    this.$bridge.$off("setCurrentGame", this.onSetGame);
  },
  methods: {
    async onSetGame(game) {
      if (!game) {
        this.$gotoHomePage();
        return;
      }

      this.formData.idGame = game.id;
      await this.loadServers(game.id);
    },
    async loadServers(idGame) {
      let servers = [
        {
          id: 0,
          name: this.$t("Select a server"),
        },
      ];

      const response = await serverGameService.getAllByGame(idGame);
      this.loading = false;
      if (!response) {
        await dialogHelper.alert(
          "Connect to server failed. Please check your internet connection"
        );
        this.$gotoHomePage();
        return;
      }
      if (response.error) {
        await dialogHelper.alert(response.message);
        this.$gotoHomePage();
        return;
      }
      this.servers = response.data;
      if (!response.data.length) {
        this.$gotoHomePage();
        return;
      }

      const { serverId } = this.$route.query;
      const server = serverId
        ? response.data.find((x) => x.serverNumber == serverId) ??
          response.data[0]
        : response.data[0];

      this.formData.idServer = server.id;
    },
  },
  watch: {
    "formData.idServer": async function () {
      this.loading = true;
      const response = await rankService.battlePower(this.formData);
      this.loading = false;

      if (!response) {
        await dialogHelper.alert(
          "Connect to server failed. Please check your internet connection"
        );
        return;
      }

      if (response.error) {
        await dialogHelper.alert(response.message);
        return;
      }

      this.rank = response.data;
    },
  },
};
</script>

<style scoped></style>
